<!--我的优惠券第2版-->
<!-- coupon-list 失效样式 -->
<template>
  <div class="main-gray-back">
    <van-tabs v-model="active" class="coupon-nav" @click="onTabChange">
      <van-tab title="全部"> </van-tab>
      <van-tab title="上架中"> </van-tab>
      <van-tab title="已下架"> </van-tab>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="row-list"
            v-for="(item, index) in list"
            :key="index"
            @click="onItemChange(item, index)"
          >
            <div
              class="sale-box"
              :style="check_index == index ? 'border:1px solid #ccc' : ''"
            >
              <div class="cell-t flex-start">
                <span class="" style="min-width: 1.4rem">套餐名称:</span>
                <span class="" style="margin-left: 0.1rem">{{
                  item.title
                }}</span>
              </div>
              <div class="cell-t flex-start">
                <span class="" style="min-width: 1.4rem">活动时间:</span>
                <div class="" style="margin-left: 0.1rem">
                  <p>开始时间{{ item.time_start | timeFormat }}</p>
                  <p>结束时间{{ item.time_end | timeFormat }}</p>
                </div>
              </div>
              <div class="cell-t flex-start">
                <span class="" style="min-width: 1.4rem">购买/订单:</span>
                <span class="" style="margin-left: 0.1rem"
                  >{{ item.order_count }}/{{ item.complete_count }}</span
                >
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh> 
    </van-tabs>
    <van-action-sheet
      v-model="show"
      @closed="onClose"
      :actions="actions"
      @select="onSelect"
    />
    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
    <div class="add-btn">
      <div class="add-b-b">
        <van-button round type="info" @click="onSalesAdd"
          >新增销售单</van-button
        >
      </div>
    </div>
    <van-overlay :show="share_show" @click="share_show = false">
      <div class="wrapper" >
        <div class="wrapper_b">
          <img
            style="width: 5rem; height: 5rem;margin-bottom:0.2rem"
            :src="share.pic_url"
            alt=""
            srcset=""
          />
          <div
          	style="text-align: center"
            v-clipboard:copy="share.url"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            {{ share.url }}
          </div>
          <div style="text-align: center" v-clipboard:copy="share.url"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError">点击链接复制</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<style scoped>
/*@import '../../../assets/style/amendVant.css';*/
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.wrapper_b {
  width: 5rem;
  background: #fff;
  padding: 0.4rem;
}
.add-btn {
  position: fixed;
  width: 100%;
  height: 1.3rem;
  bottom: 0.4rem;
}
.add-b-b {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cell-t {
  margin-bottom: 0.1rem;
  align-items: flex-start;
}
.sale-box {
  width: 6.7rem;
  margin: 0.2rem auto;
  background: #fff;
  min-height: 1rem;
  border-radius: 0.1rem;
  padding: 0.2rem;
}
.main-gray-back {
  min-height: 100%;
  background: #efefef;
}
</style>

<script>
import Vue from "vue";
import {
  Tab,
  Tabs,
  Toast,
  PullRefresh,
  List,
  ActionSheet,
  Overlay,
} from "vant";
import LoginDialog from "@/components/LoginDialog.vue";

Vue.use(Tab)
  .use(Tabs)
  .use(Toast)
  .use(PullRefresh)
  .use(List)
  .use(ActionSheet)
  .use(Overlay);
export default {
  name: "ConfigureList",
  components: {
    LoginDialog,
  },
  data: function () {
    return {
      show: false,
      share_show: false,
      share: {
        pic_url: "",
        url: "",
      },
      check_index: -1,
      actions: [
        { name: "编辑" },
        { name: "商品清单" },
        { name: "订单记录" },
        { name: "分享" },
        { name: "删除" },
      ],
      loginShow: false,
      active: 0,
      isLoading: false,
      loading: false,
      finished: false,
      params: {
        keywords: "",
        p: 1,
        step: 10,
        status: 0,
      },
      list: [],
    };
  },
  filter: {},
  mounted() {
    document.title = "销售单列表";

    let that = this;
    that.fetch();
  },
  destroyed() {},
  methods: {
    onItemChange(item, index) {
      this.check_index = index;
      this.show = true;
    },
    onSalesAdd() {
      rbLink({
        name: "ConfigureAdd",
        query: {
          id: 0,
        },
      });
    },
    onCopy(e) {
      Toast.success("复制成功");
    },
    onError(e) {
      console.log("复制失败！");
    },
    onSelect(item, index) {
      console.log(item, index);
      let that = this;
      switch (index) {
        case 0:
          rbLink({
            name: "ConfigureAdd",
            query: {
              id: that.list[that.check_index].id,
            },
          });
          break;
        case 1:
          rbLink({
            name: "SaleGoodsList",
            query: {
              id: that.list[that.check_index].id,
            },
          });
          break;
        case 2:
          rbLink({
            name: "SaleOrderList",
            query: {
              id: that.list[that.check_index].id,
            },
          });
          break;
        case 3:
          this.share_show = true;
          this.share.pic_url = that.list[that.check_index].h5_pic_url;
          this.share.url = that.list[that.check_index].h5_url;
          break;
        case 4:
            console.log('删除')
            
            let id=that.list[that.check_index].id
                that.$api.get('/api/jxc/saleDelete', {
                    id : id,
                }, (res) => {
                    that.$toast("删除成功");
                    that.list.splice(that.check_index,1)
                },(err)=>{
                    Toast(res.msg);
                })
          break;
      }
      this.show = false;
    },
    fetch(ref) {
      let that = this;
      this.$api.get(
        "/api/jxc/getSaleList",
        this.params,
        (res) => {
          that.loading = false;
          that.params.p += 1;

          if (res.data.currentpage == 1) {
            if (ref) {
              that.$toast("刷新成功");
            }
            that.isLoading = false;
            that.list = res.data.list;
          } else {
            let list = that.list.concat(res.data.list);
            that.list = list;
          }
          if (res.data.list.length == 0) {
            that.finished = true;
          }
        },
        (res) => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onClose() {
      this.check_index = -1;
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
    },
    // 上拉加载
    onLoad() {
      // 异步更新数据
      if (this.params.p > 1) {
        setTimeout(() => {
          this.fetch();
        }, 500);
      }
    },

    onRefresh() {
      let that = this;
      that.params.p = 1;
      this.fetch(1);
    },
    onTabChange(index) {
      this.params.p = 1;
      this.params.status = index;
      this.fetch(1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConfigureList.vue?28481771